export default "__VITE_PUBLIC_ASSET__8ba8ba1d__"